import React, { useContext, useEffect } from "react";
import {
  Outlet,
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import Homepage from "../component/ui/homepage";
import "bootstrap/dist/css/bootstrap.min.css";
import { Login } from "../component/ui/login";

import { Context as AuthContext } from "../context/AuthContext";
import Cookies from "js-cookie";
import DashboardLayout from "../component/layouts/dashboard";
import Dashboard from "../component/ui/dashboard";
import SearchResult from "../component/ui/searchResult";
import Booknow from "../component/ui/booknow";
import FacilityByCategory from "../component/ui/FacilityByCategory";
import Profile from "../component/ui/profile";
import UserDashboard from "../component/layouts/userDashboard";
import Bookings from "../component/ui/bookings";
import CreateFacility from "../component/CreateFacility/CreateFacility";
import AddService from "../component/ui/addService";
import Blog from "../component/ui/blog";
import BlogDetails from "../component/ui/BlogDetails";
import Userdashboard from "../component/ui/userdashboard";
import Userbooking from "../component/ui/userbooking";
import Userprofile from "../component/ui/userprofile";
import Contactus from "../component/ui/contactUs";
import PageNotFound from "../component/ui/page-not-found.js";
import HowItWorks from "../component/ui/HowItWorks.js";
import TermsAndConditions from "../component/ui/TermsAndConditions.js";
import RefundCancellationPolicy from "../component/ui/RefundCancellationPolicy.js";
import DisclaimerPage from "../component/ui/DisclaimerPage.js";
import { Navigate, useLocation } from "react-router-dom";

import {
  getHomepageData,
  getSinglePageData,
  getAllFacility,
  getFacilityByCategory,
  getCreateFacilityPageData,
} from "../config/initialApis";

import AboutusPage from "../component/ui/aboutUs";
import AllFacility from "../component/ui/allFacility";
import Hotels from "../component/ui/hotels";
import HotelDetail from "../component/ui/hotels/HotelDetail";
import Tournaments from "../component/ui/tournaments";
import RegisterTournament from "../component/ui/tournaments/RegisterTournament";
import TermsofServices from "../component/ui/Terms&Service";
import FaQ from "../component/ui/FAQ";
import PrivacyPolicy from "../component/ui/PrivacyPolicy";
import ReturnRefund from "../component/ui/Return&Refund";
import Single from "../component/ui/single";
import RouteTracker from "../component/RouteTracker.js";
import CookieConsent from "../component/ui/CookieConsent";

const CheckAuth = () => {
  const { state, userLoggedIn } = useContext(AuthContext);
  const path = useLocation();
  useEffect(() => {
    const userToken = Cookies.get("USER_TOKEN");
    if (!state.userData && userToken) {
      userLoggedIn({ token: userToken });
    }
  }, [state.userData]);

  return <Outlet />;
};
/* ================= ROOT LAYOUT (GA TRACKING) ================= */
const RootLayout = () => (
  <>
    <RouteTracker />
    <Outlet />
    <CookieConsent />
  </>
);

// ✅ Single custom login modal for all public routes
const LayoutWrapper = () => (
  <>
    <Login />
    <Outlet />
  </>
);

const ProtectedRoutes = ({ children }) => {
  const userToken = Cookies.get("USER_TOKEN");
  const location = useLocation();

  if (!userToken) {
    // ✅ Only for /dashboard
    if (location.pathname === "/dashboard") {
      return <Navigate to="/" replace state={{ showLoginModal: true }} />;
    }

    // ❌ For other routes → normal redirect
    return <Navigate to="/" replace state={{ showLoginModal: false }} />;
  }

  return children;
};

const ApplicationRoutes = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayout />}>
      <Route element={<CheckAuth />}>
        <Route element={<LayoutWrapper />}>
          <Route
            index
            path="/"
            element={<Homepage />}
            loader={getHomepageData}
          />
          {/* <Route path="/contact-us" element={<ContactusPage />} /> */}
          <Route path="/about-us" element={<AboutusPage />} />
          <Route path="/all-facilities" element={<AllFacility />} />
          <Route path="/hotels" element={<Hotels />} />
          <Route path="/hotels/:slug" element={<HotelDetail />} />
          <Route path="/tournaments" element={<Tournaments />} />
          <Route
            path="/tournaments/:id/register"
            element={<RegisterTournament />}
          />
          <Route path="/terms" element={<TermsofServices />} />
          <Route path="/faq" element={<FaQ />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/return-refund" element={<ReturnRefund />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetails />} />
          <Route path="/how-to-works" element={<HowItWorks />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route
            path="/refund-cancellation-policy"
            element={<RefundCancellationPolicy />}
          />
          <Route path="/disclaimer-page" element={<DisclaimerPage />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoutes>
                <Userdashboard />
              </ProtectedRoutes>
            }
          />
          <Route path="/booking" element={<Userbooking />} />
          <Route path="/profile" element={<Userprofile />} />
          <Route path="/contact" element={<Contactus />} />
          <Route path="*" element={<PageNotFound />} />

          <Route
            path="/facility/:slug"
            element={<Single />}
            loader={({ params }) => getSinglePageData({ params })}
          />
          <Route path="/location/:locationName" element={<SearchResult />} />
          <Route
            path="/:category/:service"
            element={<FacilityByCategory />}
            loader={({ params }) => getFacilityByCategory({ params })}
          />
          <Route
            path="/booknow/:facilityName"
            element={
              <ProtectedRoutes role={["User"]}>
                <Booknow />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/management"
            element={
              <ProtectedRoutes role={["User"]}>
                <DashboardLayout />
              </ProtectedRoutes>
            }
          >
            <Route path="/management/dashboard" element={<Dashboard />} />
            <Route
              path="/management/createfacility"
              element={<CreateFacility />}
              loader={getCreateFacilityPageData}
            />
            <Route
              path="/management/addService"
              element={<AddService />}
              loader={getAllFacility}
            />
          </Route>
          <Route
            path="/user"
            element={
              <ProtectedRoutes role={["User"]}>
                <UserDashboard />
              </ProtectedRoutes>
            }
          >
            {/* <Route path="/user/profile" element={<Profile />} /> */}
            <Route path="/user/bookings" element={<Bookings />} />
          </Route>
        </Route>
      </Route>
    </Route>,
  ),
);

export default ApplicationRoutes;
